export default "__VITE_ASSET__mTxZZPhv__"